import { render, staticRenderFns } from "./ProzessResourceName.vue?vue&type=template&id=0181ec00"
import script from "./ProzessResourceName.vue?vue&type=script&lang=js"
export * from "./ProzessResourceName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports